export default __webpack_public_path__ + "static/adrian-91a09551f2a381bfa1a5d2716bd1b847.png";